import { request } from 'graphql-request';
import { API_URL } from 'appenv';
import { GraphQLVideoCallParticipantQuitInput, GraphQLVideoCallParticipantQuitPayload } from './graphql-models';

const videoCallQuitMutation = `
  mutation videoCallParticipantQuit($participantId: String!, $roomToken: String!) {
    videoCallParticipantQuit(input: {
      participantId: $participantId,
      roomToken: $roomToken
    }) {
      success
    }
  }  
`;

const quitVideoCallRoom = (participantId: string, roomToken: string): Promise<GraphQLVideoCallParticipantQuitPayload> => request(
  API_URL,
  videoCallQuitMutation,
  {
    participantId,
    roomToken,
  } as GraphQLVideoCallParticipantQuitInput,
).then(({ videoCallParticipantQuit }) => videoCallParticipantQuit);

export default quitVideoCallRoom;
